// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-background[data-v-71fb7fde]{background-color:rgba(0,166,90,.08)}.error-background[data-v-71fb7fde]{background-color:red}.success-text-code[data-v-71fb7fde]{color:#00a65a}", ""]);
// Exports
module.exports = exports;
